import * as R from "ramda";
import { Action } from "redux";
import { AppState } from "./appState";
import ACTION_TYPE from "./ActionTypes";
import { IFilterForm } from "./overagesFilterFormActions";


export type typeOnHandDeliveryFilterForm = {
  type: ACTION_TYPE.ON_HAND_DELIVERY_FILTER_FORM_STATE;
  onHandDeliveryFilterForm: IFilterForm;
};

/**
 * Redux action to update DispatchForm in Redux State
 * @param onHandDeliveryForm - the params we use for the dispatch api put request Obtained from DispatchForm component.
 */

export const saveOnHandDeliveryFilterForm = (
    onHandDeliveryFilterForm: IFilterForm
): typeOnHandDeliveryFilterForm => ({
  type: ACTION_TYPE.ON_HAND_DELIVERY_FILTER_FORM_STATE,
  onHandDeliveryFilterForm: onHandDeliveryFilterForm,
});

export const saveOnHandDeliveryFilterFormReducer = (
  state: AppState,
  action: Action
): AppState => {
  if (action.type !== ACTION_TYPE.ON_HAND_DELIVERY_FILTER_FORM_STATE) {
    return state;
  }
  return R.mergeRight(state, {
    onHandDeliveryFilterForm: (action as typeOnHandDeliveryFilterForm)
      .onHandDeliveryFilterForm,
  });
};
